import React from "react";
import Misc from "../components/misc/Misc";
function MiscPage() {
  return <Misc />;
}

export default MiscPage;
